import { unwrap, unwrapVoid } from '../http.js';
import { paginate } from '../pagination.js';
export function createFoodsApi(client) {
    async function search(query) {
        return unwrap(await client.GET('/v1/foods', { params: { query: query ?? {} } }));
    }
    return {
        search,
        iterate(query) {
            return paginate(search, query);
        },
        async lookupBarcode(barcode) {
            return unwrap(await client.GET('/v1/foods/lookup', { params: { query: { barcode } } }));
        },
        async get(id) {
            return unwrap(await client.GET('/v1/foods/{id}', { params: { path: { id } } }));
        },
        async create(body) {
            return unwrap(await client.POST('/v1/foods', { body }));
        },
        async update(id, body) {
            return unwrap(await client.PATCH('/v1/foods/{id}', { params: { path: { id } }, body }));
        },
        async remove(id) {
            unwrapVoid(await client.DELETE('/v1/foods/{id}', { params: { path: { id } } }));
        },
        async refresh(id) {
            return unwrap(await client.POST('/v1/foods/{id}/refresh', { params: { path: { id } } }));
        },
    };
}
//# sourceMappingURL=foods.js.map